import React from 'react';
import classes from "./styles/footer.module.css";
import logo from "../../assets/footer-logo.png";
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  // const scrollToFaq = () => {
  //   const element = document.getElementById("FaqSection");
  //   if (element) {
  //     element.scrollIntoView({ behavior: 'smooth' });
  //   }else{
  //     navigate("/");
  //     const delayImport = () => {
  //       const element2 = document.getElementById("FaqSection");
  //       element2.scrollIntoView({ behavior: 'smooth' });
  //     };
  //     const timeoutId = setTimeout(() => {
  //       delayImport();
  //     }, 300);
  //     return () => clearTimeout(timeoutId);
  //   }
  // };

  const scrollToProgram = () => {
    const element = document.getElementById("ProgramSection");
    const scrollWithOffset = (el) => {
      const offset = 0;
      const topPos = el.getBoundingClientRect().top + window.pageYOffset + offset;
      window.scrollTo({ top: topPos, behavior: 'smooth' });
    };
    if (element) {
      scrollWithOffset(element);
    } else {
      navigate("/");
  
      const delayImport = () => {
        const element2 = document.getElementById("ProgramSection");
        if (element2) {
          scrollWithOffset(element2);
        }
      };
      const timeoutId = setTimeout(() => {
        delayImport();
      }, 300);
      return () => clearTimeout(timeoutId);
    }
  };

  const initiateWhatsAppChat = () => {
    const phoneNumber = "+917389940354"; // Your WhatsApp number
    const message = `Hi! I'm interested in Online Fitness & Nutrition batches. Please can you share the details!`;
    const whatsappURL = `https://wa.me/${phoneNumber.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank"); // Opens the WhatsApp link in a new tab
  };

  return (
    <>
    <div className={classes.container}>
      <div className={classes.copyrightCon}>
        <img src={logo} alt="logo" />
        {/* <h3>Get Fit With Susmita</h3> */}
        <p>&#9426; 2025 All Right Reserved</p>
      </div>


      <div className={classes.linkCon}>
        <a href="/know-your-coach">Know your coach</a>
        <button onClick={scrollToProgram}>Programs</button>
        <a href="/privacy">Privacy</a>
        <a href="https://blog.getfitwithsusmita.com" target='_blank' rel="noreferrer">Blog</a>
      </div>

      <div className={classes.ContactCon}>
        <h3>Contact</h3>
        <p><img src='https://cdn-icons-png.flaticon.com/128/0/191.png' alt='mobile'/>+91 73899 40354</p>
        <p><img src='https://cdn-icons-png.flaticon.com/128/18383/18383590.png' alt='mobile'/>hello@getfitwithsusmita.com</p>
        <p><img src='https://cdn-icons-png.flaticon.com/128/8105/8105423.png' alt='mobile'/>537 New Minal Residency <br />JK Road Bhopal 462023 MP India</p>
      </div>

      <div className={classes.socialCon}>
        <h3>Social</h3>
        <div>
          <a href="https://www.facebook.com/susmita.a.roy.1" target='_blank' rel="noopener noreferrer"><img src="https://cdn-icons-png.flaticon.com/128/2504/2504903.png" alt="" /></a>
          <a href="https://www.instagram.com/getfitwithsusmita" target='_blank' rel="noopener noreferrer"><img src="https://cdn-icons-png.flaticon.com/128/2111/2111463.png" alt="" /></a>
          <a onClick={initiateWhatsAppChat} href="https://wa.me/+917389940354?text=Hi, I would like to know more about the programs. Please schedule a call for further discussion." target='_blank' rel="noopener noreferrer"><img src="https://cdn-icons-png.flaticon.com/128/2504/2504957.png" alt="" /></a>
        </div>
      </div>
    </div>


    <div className={classes.containerMobile}>

    <div className={classes.copyrightCon}>
        <img src={logo} alt="logo" />
        <p>&#9426; 2025 All Right Reserved</p>
    </div>

      <div className={classes.linkCon}>
        <a href="/know-your-coach">Know your coach</a>
        <button onClick={scrollToProgram}>Programs</button>
        <a href="/privacy">Privacy</a>
        <a href="https://blog.getfitwithsusmita.com" target='_blank' rel="noreferrer">Blog</a>
      </div>

      <div className={classes.ContactCon}>
        <h3>Contact</h3>
        <p>+91 73899 40354</p>
        <p>hello@getfitwithsusmita.com</p>
        <p>537 New Minal Residency JK Road Bhopal 462023 MP India</p>
      </div>

      <div className={classes.socialCon}>
        <h3>Social</h3>
        <div>
          <a href="https://www.facebook.com/susmita.a.roy.1" target='_blank' rel="noopener noreferrer"><img src="https://cdn-icons-png.flaticon.com/128/2504/2504903.png" alt="" /></a>
          <a href="https://www.instagram.com/getfitwithsusmita" target='_blank' rel="noopener noreferrer"><img src="https://cdn-icons-png.flaticon.com/128/2111/2111463.png" alt="" /></a>
          <a onClick={initiateWhatsAppChat} href="https://wa.me/+917389940354?text=Hi, I would like to know more about the programs. Please schedule a call for further discussion." target='_blank' rel="noopener noreferrer"><img src="https://cdn-icons-png.flaticon.com/128/2504/2504957.png" alt="" /></a>
        </div>
      </div>
    </div>

    
    </>
  )
}

export default Footer;
